module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-management/user-management-main/user-management-main.component.scss
// module id = ./src/app/user-management/user-management-main/user-management-main.component.scss
// module chunks = main